var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"payment-method-icon"},[(_vm.iconName)?_c('img',{attrs:{"width":_vm.width,"src":require(("../assets/images/paymentMethodIcons/" + _vm.iconFolder + "/" + _vm.iconName + ".png")),"alt":_vm.paymentMethod}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }